{
    "account": "Account",
    "add_bookmark": "Voeg bericht toe aan bladwijzers",
    "add_date": "Voeg een datum toe",
    "ago": "{{duration}} geleden",
    "api_key": "API key",
    "are_you_sure": "Bent u zeker?",
    "ask_delete_message": "Verwijder dit bericht?",
    "audio_not_ready": "Audio is nog niet klaar.",
    "bookmark_added": "Bericht toegevoegd aan bladwijzers.",
    "bookmark_removed": "Bericht verwijderd uit bladwijzers.",
    "bookmarks": "bladwijzers",
    "cancel": "Annuleren",
    "cancel_write": "Bent u zeker dat u dit bericht wil annuleren?",
    "changed_group_name": "verandert de groepsnaam",
    "confirm_password_placeholder": "bevestig wachtwoord",
    "connect": "Verbind",
    "create_a_group": "Maak een groep",
    "create_the_group": "Maak de groep",
    "daily": "Elke dag",
    "default_group": "Standaard groep",
    "delete": "Verwijderen",
    "destroy_account_explain": "Indien u uw account verwijdert, kan deze niet meer worden teruggehaald.",
    "destroy_account": "Verwijder jouw account",
    "edit": "Bewerken",
    "email": "E-mail",
    "email_input": "Voeg uw e-mail adres hier in",
    "empty_message": "Dit bericht is leeg en kan niet worden verzonden.",
    "error": "Er is een fout opgetreden",
    "error_new_message": "Er is een fout opgetreden bij het doorsturen van uw bericht.",
    "error_upload": "Er is een fout opgetreden bij het uploaden",
    "forgot_password": "Wachtwoord vergeten?",
    "group_left": "U heeft de groep verlaten.",
    "groups": "Groepen",
    "group_share_choice": "Naar welke groep wenst u dit bericht te versturen?",
    "group_updated": "De groep werd aangepast.",
    "has_commented_on": "heeft commentaar gegeven op",
    "has_joined": "is erbij gekomen",
    "has_left": "is weggegaan",
    "has_posted_in": "heeft gepost in",
    "hourly": "Elk uur",
    "in": "in",
    "Invalid login/password": "Ongeldige aanmeldnaam/wachtwoord combinatie",
    "invitation_link": "Uitnodigings link",
    "invitation_welcome": "Welkom op Zusam. Gelieve aan te melden vooraleer in een groep in te schrijven.",
    "just_now": "Net",
    "lang": "taal",
    "login": "Aanmelden",
    "login_input": "Kies een aanmeldingsnaam",
    "login_placeholder": "e-mail",
    "logout": "Afmelden",
    "mark_all_as_read": "markeer als gelezen",
    "monthly": "Elke maand",
    "multiple_photos_upload": "Er is een fout opgetreden. Probeer foto's één voor één op te laden",
    "name_input": "Kies een naam",
    "name": "Naam",
    "new_password_placeholder": "nieuw wachtwoord",
    "next_coms": "Zie volgende",
    "none": "Niets",
    "notification_emails": "E-mail meldingen",
    "notification_emails_stopped": "E-mail meldingen zijn gestopt !",
    "notifications": "notificaties",
    "parent_message": "Parent bericht",
    "password_input": "Kies een nieuw wachtwoord",
    "password_placeholder": "wachtwoord",
    "password_reset_mail_sent": "Zoek in uw inbox naar de wachtwoordreset e-mail.",
    "passwords_dont_match": "Wachtwoorden komen niet overeen",
    "password": "Wachtwoord",
    "previous_coms": "Zie vorige",
    "public_link": "publieke link",
    "publish_in_group": "gepubliseerd in de groep",
    "quit_group": "Verlaat de groep",
    "remove_bookmark": "Verwijder bericht uit bladwijzers",
    "replies_one": "{{count}} antwoord",
    "replies_other": "{{count}} antwoorden",
    "reply": "antwoorden",
    "reset_api_key": "Reset de API key (u zal worden gedeconnecteerd)",
    "reset_invitation_link": "Reset uitnodiging link",
    "reset_password_title": "Reset uw wachtwoord",
    "save_changes": "Wijzigingen opslaan",
    "search_in_group": "zoek in deze groep",
    "search_without_result": "Er werd geen enkel bericht gevonden met deze criteria.",
    "settings": "Instellingen",
    "settings_updated": "Uw instellingen werden aangepast",
    "share_message": "Deel bericht",
    "signup": "Inschrijven",
    "submit": "Verstuur",
    "text_placeholder": "Schrijf jouw bericht hier",
    "the_message_from": "het bericht van",
    "title_placeholder": "Titel van jouw bericht (optioneel)",
    "to": "aan",
    "upload_audio": "Voeg een audiobestand toe.",
    "upload_image": "Voeg foto's toe",
    "upload_music": "Voeg muziek toe",
    "upload_pdf": "Voeg PDF toe",
    "upload_video": "Voeg filmpje toe",
    "User not found": "Gebruiker niet gevonden",
    "users": "gebruikers",
    "video_not_ready": "Video is nog niet klaar.",
    "weekly": "Elke week"
}
